/**
 * Build tpoPricing / torPricing arrays from /api/product-rates response.
 * API returns: cover_type, vehicle_class, period, base_amount, gross_amount, is_tonnage_based, is_psv_pricing, passenger_fee, tonnage_ranges.
 */
const GROSS_FACTOR = 1.0045;
const STAMP_DUTY = 40;

export function grossFromNet(net) {
  if (net == null || isNaN(Number(net))) return 0;
  return Math.ceil(Number(net) * GROSS_FACTOR + STAMP_DUTY);
}

/** Get customer amount from tonnage_ranges (array of { max, amount }) for a given tonnage. NET: amount as-is. GROSS TPO: net → gross. TOR: amount as-is (stored gross). */
export function amountFromTonnageRanges(tonnageRanges, tonnage, coverType, isNet = false) {
  if (!tonnageRanges || !Array.isArray(tonnageRanges) || tonnageRanges.length === 0) return null;
  const t = parseFloat(tonnage);
  if (isNaN(t)) return null;
  let bandAmount = null;
  for (const band of tonnageRanges) {
    const max = band.max != null ? Number(band.max) : 999;
    if (t <= max) {
      bandAmount = band.amount != null ? Number(band.amount) : null;
      break;
    }
  }
  if (bandAmount == null) return null;
  if (isNet) return bandAmount; // NET class: customer pays this amount as-is
  return coverType === 'TOR' ? Math.ceil(bandAmount) : grossFromNet(bandAmount);
}

/** Build pricing arrays from API rates. Returns { tpoPricing, torPricing }. */
export function buildPricingFromRates(rates) {
  if (!rates || !Array.isArray(rates) || rates.length === 0) return null;
  const tpo = [];
  const tor = [];
  for (const r of rates) {
    const label = r.vehicle_class || '';
    const period = r.period || (r.cover_type === 'TOR' ? '1 Month' : '1 Year');
    const stored = r.base_amount != null ? Number(r.base_amount) : 0;
    // TOR is stored as the customer amount (no stamp/levies). Using API gross_amount would
    // wrongly charge 503 + 40 + 0.45% = 545.26 for Motorcycle PSV TOR.
    const amount = r.cover_type === 'TOR'
      ? stored
      : (r.gross_amount != null ? Number(r.gross_amount) : grossFromNet(stored));
    const entry = {
      label,
      amount,
      period,
      tonnageBased: !!r.is_tonnage_based,
      psvPricing: !!r.is_psv_pricing,
      passengerFee: r.passenger_fee != null ? Number(r.passenger_fee) : undefined,
      tonnageRanges: r.tonnage_ranges || undefined,
      baseAmount: r.base_amount != null ? Number(r.base_amount) : undefined,
      coverType: r.cover_type,
      isNet: !!r.is_net
    };
    if (r.cover_type === 'TPO') tpo.push(entry);
    else if (r.cover_type === 'TOR') tor.push(entry);
  }
  return { tpoPricing: tpo, torPricing: tor };
}
